export const DASHBOARD_TYPE = {
    STANDARD: 1,
    SHARED: 2,
  };